import { Component } from '@angular/core';

import { ReportsService } from '../../../services/reports.service';

@Component({
  selector: 'custom-status-bar-row-count',
  template: `
    <div *ngIf="rptService.selectedRows.length" style="padding: 8px">
      <span>{{ 'AGGRIDLOCALE.selectedRows' | translate }}:&nbsp;</span>
      <span style="color: black">{{ rptService.selectedRows.length }}</span>
    </div>
  `,
  styles: [],
})
export class CustomStatusBarSelectedCountComponent {
  constructor(public rptService: ReportsService) {}

  agInit(): void {}
}
